import * as angular from 'angular';

let nextId = Date.now();

interface IRadioScope extends angular.IScope {
    uid: string;
    change: () => void;
}

class RadioDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';
    readonly scope = {
        group: '@',
        value: '=ngValue',
        model: '=ngModel',
        change: '&?ngChange'
    };

    readonly template = `
        <div class="fc-radio">
            <label for="{{ uid }}" layout="row" layout-align="start center">
                <div class="fc-radio-input">
                    <input id="{{ uid }}" type="radio" name="{{ group }}" ng-value="value" ng-model="model" ng-change="change({ value: model })" />
                    <span></span>
                </div>
                <div class="fc-radio-label" ng-transclude></div>
            </label>
        </div>
    `;

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(scope: IRadioScope): void {
        scope.uid = `fc-radio__${nextId++}`;
        scope.change = scope.change || angular.noop;
    }
}

const RadioDirectiveFactory: angular.IDirectiveFactory = () => new RadioDirective();

export { RadioDirectiveFactory };
